import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CreateLabelRequest, LabelId, UpdateLabelRequest } from "@mailflare/shared";

import { queryKeys } from "@/lib/query-keys";

import { createLabel, deleteLabel, listLabels, updateLabel } from "./api";

export function useLabels() {
  return useQuery({ queryKey: queryKeys.labels, queryFn: listLabels, staleTime: 60_000 });
}

export function useCreateLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateLabelRequest) => createLabel(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.labels });
    },
  });
}

export function useUpdateLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables: { readonly labelId: LabelId; readonly body: UpdateLabelRequest }) =>
      updateLabel(variables.labelId, variables.body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.labels });
    },
  });
}

export function useDeleteLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (labelId: LabelId) => deleteLabel(labelId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.labels });
    },
  });
}
